import { getAccessToken, setAccessToken, clearAccessToken } from "./auth.js";

export const API_BASE = (import.meta.env["VITE_API_URL"] as string | undefined) ?? "";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const token = getAccessToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(init?.headers as Record<string, string>),
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, { ...init, headers });

  // Sliding-window refresh: backend sends a new token when <15 min remain.
  // Silently swap it in so the user stays logged in without any extra request.
  const refreshed = res.headers.get("X-Refresh-Token");
  if (refreshed) {
    setAccessToken(refreshed);
  }

  if (res.status === 401) {
    clearAccessToken();
    window.location.href = "/login";
    throw new ApiError(401, "UNAUTHORIZED", "Session expired");
  }

  if (!res.ok) {
    const body = (await res.json().catch(() => ({ error: { code: "UNKNOWN", message: res.statusText } }))) as {
      error: { code: string; message: string };
    };
    throw new ApiError(res.status, body.error.code, body.error.message);
  }

  return res.json() as Promise<T>;
}
